
import React from 'react';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-user-add-line',
      title: '快速配對',
      description: '與內地官方指定勞務機構合作，精選符合您需求的優質外勞。',
      features: ['14間官方勞務公司', '每日提供人選', '嚴格篩選標準']
    },
    {
      icon: 'ri-file-text-line',
      title: '簽證申請',
      description: '代辦入境署所需文件及簽證申請，確保流程順暢。',
      features: ['文件準備', '申請代辦', '進度跟進']
    },
    {
      icon: 'ri-graduation-cap-line',
      title: '專業培訓',
      description: '與培訓機構合作，確保外勞抵港前接受專業培訓，滿足各行業需求。',
      features: ['行業專業培訓', '語言能力提升', '工作技能認證']
    },
    {
      icon: 'ri-heart-line',
      title: '貼心支援',
      description: '提供醫療、生活支援、舒適住宿、到港適應活動及諮詢調解服務。',
      features: ['醫療保障', '生活適應', '24小時支援']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            我們的服務
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            從外勞配額申請到尋找合適人選，我們全程協助
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${service.icon} text-green-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">
                <i className="ri-checkbox-circle-fill text-green-500 mr-2"></i>
                {service.title}
              </h3>
              <p className="text-gray-600 mb-4 text-center">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            我們致力於透明、專業的服務，保障僱主與勞工的權益，實現雙贏局面。
          </p>
          <div className="bg-green-600 text-white p-8 rounded-xl">
            <h3 className="text-2xl font-bold mb-4">與內地官方勞務機構合作</h3>
            <p className="text-lg">
              我們與內地官方指定勞務公司攜手，確保招聘過程合法、透明，為您提供可靠、高質量的外勞資源。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
